import { useTranslation } from "react-i18next"
import { DotPill, Tone } from "../../delivery/atoms"

// RouteMap.tsx keeps the same palette so map and stop list read in lockstep.
const TONES: Record<string, Tone> = {
  PENDING:   "amber",
  ARRIVED:   "blue",
  COMPLETED: "green",
  FAILED:    "red",
  SKIPPED:   "grey",
}

interface Props {
  status: string | null | undefined
  /** Kept for call-site compatibility; the pill has one size. */
  size?: unknown
}

/** Stop status as a dot pill (Ord_RouteDetail «Зогсоолын дараалал»). */
export function StopStatusBadge({ status }: Props) {
  const { t } = useTranslation(["delivery"])
  if (!status) return <>-</>
  return <DotPill tone={TONES[status] ?? "grey"}>{t(`delivery:route.stopStatus.${status}`, { defaultValue: "-" })}</DotPill>
}
